<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Dialog from 'primevue/dialog';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';

const relayHubStore = useRelayHubStore();

const { organizationsAbleToConnect } = storeToRefs(relayHubStore);
const selectedItem = ref();
const district_medicaid_code = ref<string>();

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.SAVE): void;
}>();

const modalVisible = ref(true);

const save = async () => {
  await relayHubStore.addNewOrganization(district_medicaid_code.value as string, selectedItem.value);
  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Connected');

  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItem.value = null;
  emit(EMIT.CANCEL);
};
</script>

<template>
  <Dialog v-model:visible="modalVisible" class="dialog__container" :modal="true" :draggable="false" @hide="cancel">
    <template #header>
      <div class="dialog__header flex flex-column w-8">
        <h2 class="mb-3">Connect Organization</h2>
      </div>
    </template>
    <div clas="flex flex-column ">
      <div class="w-full my-3 flex flex-column gap-1">
        <label for="organizations" class="required">Organizations</label>
        <Dropdown
          id="organizations"
          v-model="selectedItem"
          class="w-full"
          :options="organizationsAbleToConnect"
          option-label="name"
          option-value="id"
          :loading="relayHubStore.loading"
          placeholder="Select an Organization"
        />
      </div>
      <div class="w-full my-3 flex flex-column gap-1">
        <label class="required" for="dmc">District Medicaid Code</label>
        <InputText id="dmc" v-model="district_medicaid_code" class="w-full" />
      </div>
    </div>
    <template #footer>
      <AppButton type="secondary" text="Cancel" @click="cancel" />
      <AppButton
        type="primary"
        text="Connect Organization"
        :disabled="!selectedItem || !district_medicaid_code"
        @click="save"
      />
    </template>
  </Dialog>
</template>
